import { Linking, View } from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";

import { Colors } from "colors";
import { ColumnItem } from "./PLP/ColumnItem";
import ImageView from "../../src/image";
import ListView from "./ListView";
import ProductCard from "./PLP/ProductCard";
import { StyleSheet } from "react-native";
import VText from "./VText";
import Heading from "./Heading";
import { useCallback } from "react";

const StoryListItem = ({ data = {}, id, index = 0, _productPDPRef, gender, story_title = "" }) => {
    const [productList, setProducts] = useState([]);

    useEffect(() => {
        if (data?.products && Array.isArray(data?.products)) {
            setProducts(data?.products);
        }
    }, [data?.products]);

    const renderItem = useCallback(
        ({ item, index }) => {
            return (
                <ProductCard
                    gender={gender}
                    containerStyle={{
                        width: wp(377.333333333),
                        height: "auto",
                    }}
                    imageStyle={{
                        width: wp(377.333333333),
                        height: hp(503.11),
                    }}
                    showAddCart={false}
                    product={item}
                />
            );
        },
        [data, productList]
    );

    return (
        <View style={styles.container}>
            <View style={styles.rowContainer}>
                {data?.imageUrl && (
                    <View style={styles.imageContainer}>
                        <ImageView
                            alt={data?.story_title}
                            source={{
                                uri: data?.imageUrl,
                                priority: ImageView.priority.high,
                            }}
                            style={styles.image}
                        />
                        {data?.imageDescription && (
                            <Heading type="h5" style={styles.imageDescription}>
                                {data?.imageDescription}
                            </Heading>
                        )}
                    </View>
                )}
                <View style={styles.contentContainer}>
                    <VText
                        style={{
                            fontSize: fp(24),
                            fontFamily: "LibreBodoni",
                            fontWeight: "400",
                            color: Colors.black,
                            paddingBottom: spV(8),
                        }}
                        text={data?.imageHeader}
                    />
                    {data?.content && <VText style={styles.content} text={data.content} />}
                    <View style={styles.featuredProductsContainer}>
                        {productList?.slice(0, 2).map((item, index) => (
                            <View key={index} style={styles.featuredProductItem}>
                                <ProductCard
                                    gender={gender}
                                    containerStyle={{ width: wp(230) }}
                                    showAddCart={false}
                                    product={item}
                                    product_position={index + 1}
                                    isStoryProduct={true}
                                    storyId={id}
                                    story_title={story_title}
                                />
                            </View>
                        ))}
                    </View>
                </View>
            </View>

            <ListView
                data={Array.isArray(productList) ? productList?.slice(2) : []}
                estimatedItemSize={500}
                extraData={[]}
                contentContainerStyle={{}}
                numColumns={3}
                columnWrapperStyle={{ justifyContent: "space-between" }}
                showsVerticalScrollIndicator={false}
                keyExtractor={(item, index) => index.toString()}
                renderItem={({ item, index }) => (
                    <ProductCard
                        gender={gender}
                        containerStyle={{
                            width: wp(377.333333333),
                            height: "auto",
                            marginBottom: spV(24),
                        }}
                        isStoryProduct={true}
                        imageStyle={{
                            width: wp(377.333333333),
                            height: hp(503.11),
                        }}
                        storyId={id}
                        product_position={index + 3}
                        story_title={story_title}
                        showAddCart={false}
                        product={item}
                    />
                )}
            />

            {/* <View style={{ width: "100%", flexDirection: "row", flexWrap: "wrap", marginLeft: -5, marginTop: spV(20) }}>
                {productList?.map((item, index) => (
                    <View key={index.toString()} style={styles.productGridItem}>
                        {renderItem({ item, index })}
                    </View>
                ))}
            </View> */}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        backgroundColor: "white",
        flex: 1,
    },
    productGrid: {
        width: "100%",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "flex-start", // Changed from space-between to flex-start
        paddingHorizontal: spH(8),
    },
    productGridItem: {
        width: "32%", // Adjust this value to change the item width
        marginBottom: spV(16),
        marginHorizontal: spH(5), // Added horizontal margin
    },
    rowContainer: {
        flexDirection: "row",
        marginTop: spV(12),
    },
    featuredProductsContainer: {
        flexDirection: "row",
        marginTop: spV(16),
        marginBottom: spV(16),
    },
    featuredProductItem: {
        marginHorizontal: spH(16),
        overflow: "hidden",
    },
    additionalContent: {
        marginTop: spV(24), // Adjusted margin
        marginBottom: spV(16), // Added margin bottom
        fontSize: fp(15),
        fontWeight: "350",
        color: "#212427",
    },
    imageContainer: {
        width: "50%",
    },
    image: {
        height: spV(600),
    },
    imageDescription: {
        fontSize: fp(13),
        fontWeight: "350",
        color: Colors.black,
        marginTop: spV(10),
    },
    contentContainer: {
        width: "50%",
        marginLeft: spH(2),
        padding: spH(16),
        paddingTop: 0,
    },
    content: {
        fontSize: fp(16),
        fontWeight: "350",
        color: Colors.black,
        lineHeight: "140%",
    },
    additionalContent: {
        marginTop: 16,
        fontSize: 15,
        fontWeight: "350",
        color: "#212427",
    },
    listContainer: {
        // flexDirection: "row",
        // alignItems: "center",
        // justifyContent: "space-between",
    },
});

export default StoryListItem;
